import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_LMS_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";


export const GetAttendanceCodeHelper = async () => {
    return await axiosInstance(`/lms/getAttendanceBulkNotation`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain()
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateAttendanceCodeHelper = async (params) => {
    toast.info("Adding...")
    return await axiosInstance(`/lms/addAttendanceBulkNotation`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            meepl_label: params?.meepl_label,
            company_label: params?.company_label,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Code added successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const DeleteAttendanceCodeHelper = async (params) => {
    toast.info("Deleting...")
    return await axiosInstance(`/lms/deleteAttendanceBulkNotation`, {
        method: "DELETE",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            attendance_bulk_notation_mapping_pk: params?.attendance_bulk_notation_mapping_pk,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Code deleted successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}